module.exports = __webpack_public_path__ + "img/quard8.9279fc39.png";